var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMatavfall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2371_327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.654052 11.8261C0.654052 11.8261 4.07007 7.49473 9.0751 6.70022C14.0801 5.90571 12.9195 9.20091 21.2783 6.70022C28.601 4.86956 31.1749 11.2696 32.1708 12.7414C32.1708 12.7414 29.271 11.5222 26.8325 12.3753C26.038 12.6792 25.6133 13.6348 25.4888 14.0412C24.8188 14.0412 21.7689 10.6105 12.8573 13.4188C11.3488 13.5615 9.25451 11.7053 6.20462 13.5359C5.28929 13.6567 1.97579 11.6686 0.650391 11.8261H0.654052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4165 7.55337C14.2966 2.6655 11.7812 0.911723 11.7812 0.911723L13.2458 0.245361L16.4165 7.55337Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4945 31.4509C28.4588 33.234 27.0785 34.7461 23.3549 32.9155C17.3137 36.0276 13.7476 33.4464 13.7476 33.4464C12.1988 33.7393 11.3311 34.7461 7.36589 32.4285C5.7183 32.7324 3.94987 33.5891 1.3247 31.4509C1.3247 31.4509 1.01715 39.9965 15.9078 40.0001C31.5892 40.0038 30.4908 31.4509 30.4908 31.4509H30.4945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.654297 11.8262C1.48176 13.1589 2.59114 15.0774 3.96414 15.839C4.85384 16.3296 5.95956 16.8459 6.08771 17.8564C6.14263 18.2957 5.99617 18.7717 6.20121 19.1635C6.46482 19.6578 7.54125 19.731 8.05018 19.9616C8.73118 20.2692 9.2218 20.9685 9.27672 21.7154C9.33164 22.4587 8.99114 23.1653 8.7678 23.8756C8.50052 24.7214 8.39434 25.6184 8.45658 26.5044C8.47123 26.6948 8.48954 26.8925 8.41631 27.0719C8.24789 27.4857 7.70601 27.5662 7.34354 27.8262C6.70281 28.2875 6.70281 29.2431 6.25613 29.8912C5.79114 30.5648 2.13347 31.3447 1.32432 31.4509",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4946 31.4508C29.6671 30.8687 29.1545 30.6453 28.2831 30.4989C27.8511 30.4257 27.4044 30.422 26.9907 30.2756C25.2662 29.6568 26.0754 27.0646 24.3435 26.4751C24.0763 26.3836 23.7614 26.3323 23.604 26.098C23.5161 25.9625 23.5014 25.7904 23.4905 25.6293C23.4575 25.0252 23.4648 24.4174 23.5124 23.8133C23.56 23.2092 23.6369 22.5538 23.311 22.0412C23.1719 21.8215 22.9632 21.6312 22.9413 21.3749C22.912 21.027 23.2451 20.7598 23.571 20.628C23.8969 20.4998 24.263 20.4266 24.5046 20.174C24.966 19.6943 24.7097 18.8559 25.0612 18.292C25.2332 18.0174 25.5262 17.8453 25.83 17.7282C26.9248 17.3071 26.8625 17.395 27.895 16.8458C28.5797 16.4797 28.133 15.7328 28.803 15.341C29.4218 14.9785 30.1504 14.6746 30.674 14.1877C31.15 13.7483 31.7431 13.265 32.1715 12.7488",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2371_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8133,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMatavfall);
export default __webpack_public_path__ + "static/media/icon-matavfall.e9cabe799057ee1e1363a5327f87aa47.svg";
export { ForwardRef as ReactComponent };